import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//引入图片懒加载插件
import Lazyload from "vue3-lazyload";

const app = createApp(App);
import Video from "video.js";
import "video.js/dist/video-js.min.css";
// 挂载全局 video.js
app.config.globalProperties.$video = Video;
//注册插件
app.use(Lazyload, {
   loading: "",//可以指定加载中的图像
   error: "",//可以指定加载失败的图像
});


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus)
app.mount('#app')